export const initialStockForm = {
    id: null,
    quantidade: '',
    estoque_minimo: 0,
    solicita_palete_automaticamente: false
};

const getYesterdayDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 1);

    return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
    ].join('-');
};

export const initialState = {
    loading: false,
    executing: false,
    errorDialogVisible: false,
    stockDialogVisible: false,
    stockForm: { ...initialStockForm },
    activeIndex: 0,
    consumptionDate: getYesterdayDate(),
    consumptionLoading: false,
    consumptionReport: {
        artigos: [],
        tramas: [],
        artigo_maquinas: []
    },
    proximaTentativaEm: null,
    ultimaExecucaoEm: null,
    statusRotina: 'pendente',
    dataReferencia: null,
    pesoTotalNecessario: 0,
    estoqueTotalDisponivel: 0,
    totalItensEstoqueBaixo: 0,
    totalPendencias: 0,
    totalMetrosProduzidos: 0,
    totalArtigos: 0,
    fios: [],
    fiosSpi: [],
    stockFilter: 'todos',
    artigos: [],
    erros: []
};

export const actions = {
    LOAD_DASHBOARD_START: 'LOAD_DASHBOARD_START',
    LOAD_DASHBOARD_SUCCESS: 'LOAD_DASHBOARD_SUCCESS',
    LOAD_DASHBOARD_FINISH: 'LOAD_DASHBOARD_FINISH',
    EXECUTE_ROUTINE_START: 'EXECUTE_ROUTINE_START',
    EXECUTE_ROUTINE_FINISH: 'EXECUTE_ROUTINE_FINISH',
    OPEN_ERROR_DIALOG: 'OPEN_ERROR_DIALOG',
    CLOSE_ERROR_DIALOG: 'CLOSE_ERROR_DIALOG',
    OPEN_STOCK_DIALOG: 'OPEN_STOCK_DIALOG',
    CLOSE_STOCK_DIALOG: 'CLOSE_STOCK_DIALOG',
    CHANGE_STOCK_FORM: 'CHANGE_STOCK_FORM',
    CHANGE_ACTIVE_INDEX: 'CHANGE_ACTIVE_INDEX',
    CHANGE_CONSUMPTION_DATE: 'CHANGE_CONSUMPTION_DATE',
    CHANGE_STOCK_FILTER: 'CHANGE_STOCK_FILTER',
    LOAD_CONSUMPTION_REPORT_START: 'LOAD_CONSUMPTION_REPORT_START',
    LOAD_CONSUMPTION_REPORT_SUCCESS: 'LOAD_CONSUMPTION_REPORT_SUCCESS',
    LOAD_CONSUMPTION_REPORT_FINISH: 'LOAD_CONSUMPTION_REPORT_FINISH',
    LOAD_ROUTINE_ERRORS_SUCCESS: 'LOAD_ROUTINE_ERRORS_SUCCESS'
};

// Mantém o contrato da API isolado do formato usado pela tela.
const buildDashboardState = (data) => ({
    proximaTentativaEm: data.proxima_tentativa_em || null,
    ultimaExecucaoEm: data.ultima_execucao_em || null,
    statusRotina: data.status_rotina || 'pendente',
    dataReferencia: data.data_referencia || null,
    pesoTotalNecessario: data.peso_total_necessario || 0,
    estoqueTotalDisponivel: data.estoque_total_disponivel || 0,
    totalItensEstoqueBaixo: data.total_itens_estoque_baixo || 0,
    totalPendencias: data.total_pendencias || 0,
    totalMetrosProduzidos: data.total_metros_produzidos || 0,
    totalArtigos: data.total_artigos || 0,
    fios: data.fios || [],
    fiosSpi: data.fios_spi || [],
    artigos: data.artigos || [],
    erros: data.erros || []
});

export const controleEstoqueFioReducer = (state, action) => {
    switch (action.type) {
        case actions.LOAD_DASHBOARD_START:
            return {
                ...state,
                loading: true
            };
        case actions.LOAD_DASHBOARD_SUCCESS:
            return {
                ...state,
                ...buildDashboardState(action.payload || {})
            };
        case actions.LOAD_DASHBOARD_FINISH:
            return {
                ...state,
                loading: false
            };
        case actions.EXECUTE_ROUTINE_START:
            return {
                ...state,
                executing: true
            };
        case actions.EXECUTE_ROUTINE_FINISH:
            return {
                ...state,
                executing: false
            };
        case actions.OPEN_ERROR_DIALOG:
            return {
                ...state,
                errorDialogVisible: true
            };
        case actions.CLOSE_ERROR_DIALOG:
            return {
                ...state,
                errorDialogVisible: false
            };
        case actions.OPEN_STOCK_DIALOG:
            return {
                ...state,
                stockDialogVisible: true,
                stockForm: { ...action.payload }
            };
        case actions.CLOSE_STOCK_DIALOG:
            return {
                ...state,
                stockDialogVisible: false,
                stockForm: { ...initialStockForm }
            };
        case actions.CHANGE_STOCK_FORM:
            return {
                ...state,
                stockForm: {
                    ...state.stockForm,
                    ...action.payload
                }
            };
        case actions.CHANGE_ACTIVE_INDEX:
            return {
                ...state,
                activeIndex: action.payload
            };
        case actions.CHANGE_CONSUMPTION_DATE:
            return {
                ...state,
                consumptionDate: action.payload
            };
        case actions.CHANGE_STOCK_FILTER:
            return {
                ...state,
                stockFilter: action.payload
            };
        case actions.LOAD_CONSUMPTION_REPORT_START:
            return {
                ...state,
                consumptionLoading: true
            };
        case actions.LOAD_CONSUMPTION_REPORT_SUCCESS:
            return {
                ...state,
                consumptionReport: {
                    artigos: action.payload.artigos || [],
                    tramas: action.payload.tramas || [],
                    artigo_maquinas: action.payload.artigo_maquinas || []
                }
            };
        case actions.LOAD_CONSUMPTION_REPORT_FINISH:
            return {
                ...state,
                consumptionLoading: false
            };
        case actions.LOAD_ROUTINE_ERRORS_SUCCESS:
            return {
                ...state,
                erros: action.payload || []
            };
        default:
            return state;
    }
};
